/**
 * Arabisch (dir=rtl): Maßketten, Normbezeichnungen, Einheiten, Preise und E-Mail-Adressen in
 * Text, den der Browser erzeugt (Konfiguratoren, Zusammenfassungen), mit <bdi dir="ltr"> isolieren.
 * Der Server macht dasselbe für das ausgelieferte HTML (server/lib/rtl.ts); Muster: shared/rtl-ltr.ts.
 */
import { ltrAbschnitte } from "../shared/rtl-ltr.ts";

const SPERR = "script,style,textarea,option,select,bdi,svg,canvas,[contenteditable],[dir='ltr']";

function isoliere(knoten: Text): void {
  const eltern = knoten.parentElement;
  if (!eltern || eltern.closest(SPERR)) return;
  const text = knoten.data;
  const treffer = Array.from(text.matchAll(ltrAbschnitte()));
  // Von hinten nach vorn, damit die Offsets der Treffer davor gültig bleiben.
  for (const m of treffer.reverse()) {
    if (m.index === undefined) continue;
    const bereich = document.createRange();
    bereich.setStart(knoten, m.index);
    bereich.setEnd(knoten, m.index + m[0].length);
    const bdi = document.createElement("bdi");
    bdi.dir = "ltr";
    bereich.surroundContents(bdi);
  }
}

function durchlaufe(wurzel: Node): void {
  if (wurzel.nodeType === Node.TEXT_NODE) {
    isoliere(wurzel as Text);
    return;
  }
  if (wurzel.nodeType !== Node.ELEMENT_NODE) return;
  const lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT);
  const knoten: Text[] = [];
  for (let n = lauf.nextNode(); n; n = lauf.nextNode()) knoten.push(n as Text);
  for (const k of knoten) isoliere(k);
}

if (document.documentElement.dir === "rtl") {
  durchlaufe(document.body);
  let offen = new Set<Node>();
  let geplant = false;
  const verarbeite = (): void => {
    geplant = false;
    const aufgaben = offen;
    offen = new Set();
    for (const n of aufgaben) if (n.isConnected) durchlaufe(n);
  };
  new MutationObserver((eintraege) => {
    for (const e of eintraege) {
      if (e.type === "characterData") offen.add(e.target);
      else e.addedNodes.forEach((n) => offen.add(n));
    }
    if (!geplant && offen.size > 0) {
      geplant = true;
      queueMicrotask(verarbeite);
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
}
